export default class ClearNotificationTimer {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    this.context.scheduler.cancel(id);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/notification/clear_notification_timer.js